import { render, staticRenderFns } from "./plain.vue?vue&type=template&id=62ee2f16&scoped=true&"
import script from "./plain.vue?vue&type=script&lang=js&"
export * from "./plain.vue?vue&type=script&lang=js&"
import style0 from "./plain.vue?vue&type=style&index=0&id=62ee2f16&prod&lang=scss&"
import style1 from "./plain.vue?vue&type=style&index=1&id=62ee2f16&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62ee2f16",
  null
  
)

export default component.exports